import { RobotoFontWrapper } from '@/app/Components/IPWebsiteRedesign/RobotoFont'
import React, { useEffect } from "react";

import PrivacyPolicy from '@/app/Components/PreviewPage/PrivacyPolicy'
import Layout from './ResearchGoal/Layout'
import Head from 'next/head'


const Privacy = () => {

    useEffect(() => {
      document.body.style.margin = '0';
    }, []);

  return (
    <div>
      <Head>
        <title>Ideapoke Privacy Policy</title>
        <meta
          content="Learn how Ideapoke collects, uses, and protects your personal information. Read our comprehensive privacy policy to understand your rights and our practices."
          name="description"
        />
        <meta
          content="Ideapoke Privacy Policy"
          property="og:title"
        />
        <meta
          content="Learn how Ideapoke collects, uses, and protects your personal information. Read our comprehensive privacy policy to understand your rights and our practices."
          property="og:description"
        />
        <meta
          content="privacy policy, data protection, personal information, information security, user privacy, privacy practices"
          property="og:keywords"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="og:image"
        />
        <meta
          content="Ideapoke Privacy Policy"
          property="twitter:title"
        />
        <meta
          content="Learn how Ideapoke collects, uses, and protects your personal information. Read our comprehensive privacy policy to understand your rights and our practices."
          property="twitter:description"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="twitter:image"
        />
        <meta
          content="privacy policy, data protection, personal information, information security, user privacy, privacy practices"
          property="og:keywords"
        />

        <meta property="og:type" content="website" />
        <meta content="summary_large_image" name="twitter:card" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
        <link rel="shortcut icon" href="/ipimages/enterprise/images/ufoant.ico" />
        <link
          rel="icon"
          type="image/ico"
          href="/ipimages/enterprise/images/ufoant.ico"
        />
        <link
          rel="apple-touch-icon"
          href="/ipimages/enterprise/images/ufoant.ico"
        />
      </Head>
      {/* <Head>
    <title>Privacy Policy</title>
    <link rel="shortcut icon" href="/ipimages/enterprise/images/ufoant.ico" />
    <link rel="icon" type="image/ico" href="/ipimages/enterprise/images/ufoant.ico" />
    <link rel="apple-touch-icon" href="/ipimages/enterprise/images/ufoant.ico" />
    </Head> */}
      <RobotoFontWrapper>
        <Layout>
          <PrivacyPolicy />
        </Layout>
      </RobotoFontWrapper>
    </div>
  )
}

export default Privacy